module.exports = __webpack_public_path__ + "img/个人养老金.b0afa906.png";